var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8572 30.7143H55V60H12.8572V30.7143Z",
    fill: "#FF640E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.3804,
    height: 50,
    rx: 3.28659,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95862 23.3983C15.4308 23.3983 21.4883 17.3409 21.4883 9.86867C21.4883 5.97656 19.8448 2.4683 17.214 0H3.28659C1.47146 0 0 1.47146 0 3.28659V20.8111C2.23336 22.4383 4.98387 23.3983 7.95862 23.3983Z",
    fill: "#FF640E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 30.7143H0.714233",
    stroke: "#FF640E",
    strokeWidth: 0.16433
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5751 0V55.2328",
    stroke: "#FF640E",
    strokeWidth: 0.16433
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5336 4.29767L19.3394 52.1289H27.5367L3.74048 4.29767",
    stroke: "black",
    strokeWidth: 1.6433
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4779 44.8866L26.9001 51.731H19.9761L23.4779 44.8866Z",
    fill: "#FF640E",
    stroke: "black",
    strokeWidth: 0.16433
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.454 4.29767V52.0494M3.82007 4.29767V52.0494",
    stroke: "black",
    strokeWidth: 1.6433
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e699a405b1ab6d57f24906d36d1e4320.svg";
export { ForwardRef as ReactComponent };